import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next'; // Import de la fonction useTranslation
import GoBack from "../../components/goBack";
import Client from "../../components/Client";
import useAuthHelper from "../../helpers/AuthHelper";

const NewClient = (props, goback = true) => {
    const { onlyCommercial } = useAuthHelper();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [displayEdit, setDisplayEdit] = useState('none');
    const { t } = useTranslation(); // Utilisation de la fonction de traduction

    useEffect(() => {
        onlyCommercial();
    }, []);

    return (
        <>
            <div className="main-container container-fluid">
                {goback && props.from !== 'new_fv' ? <GoBack route='/clients/list' /> : null}
                <div className="page-header" style={{ display: props.from === 'new_fv' ? 'none' : '' }}>
                    <h1 className="page-title breadcumpsHeader">
                        {props.clientType === 'fournisseurs' ? t('Fournisseurs') : t('Clients')}
                    </h1>
                    <div>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="javascript:void(0)"
                                   onClick={() => props.clientType === 'fournisseurs' ? navigate('/fournisseurs/list') : navigate('/clients/list')}>
                                    {t('Liste des')} {props.clientType === 'fournisseurs' ? t('fournisseurs') : t('clients')}
                                </a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                {t('ajouter un')} {props.clientType === 'fournisseurs' ? t('fournisseur') : t('client')}
                            </li>
                        </ol>
                    </div>
                </div>

                <Client type={props.clientType} from={props.from} handleSave={props.handleSave} />
            </div>
        </>
    );
}

export default NewClient;
